import { connect } from 'react-redux';
import mapDispatchToProps from './mapDispatchToProps';
import Component from './MemberForm';
import mapStateToProps from './mapStateToProps';

export default connect(mapStateToProps, mapDispatchToProps)(Component);
